/**
 * Unique identifier for the Welcome feature group.
 */
export const WELCOME_FEATURE_GROUP_ID = "WELCOME_FEATURE_GROUP";
